module.exports = __webpack_public_path__ + "static/media/wizwormlogoblack.d7a67f35.png";